export { ActivitiesComponent } from './activities.component';
